export const STRINGS_CULTIVARES = { 
    BOTAO_CONFIRMAR_ASSINATURAS: "Confirmar",
    TITULO_CONFIRMAR_ASSINATURAS: "Confirmar Submissão de Arquivos Assinados",
    CONFIRMAR_ASSINATURAS: "ATENÇÃO! Não é permitido submeter ao regulatório uma solicitação sem ter o Relatório Técnico e a Tabela de Descritores assinados. Favor providenciar ambos para seguir. ",
    CIENTE_DOCUMENTO_ASSINADO: "Estou ciente de que estou enviando o documento assinado, validado e em formato PDF.",
    ERRO_RELATORIO_TECNICO_OBRIGATORIO: "Relatório técnico em PDF é obrigatório.",
    ERRO_TABELA_DESCRITORES_OBRIGATORIA: "Tabela de descritores em PDF é obrigatória.",
    ERRO_CIENTE_DOCUMENTO: "Confirme a ciência de que o documento está assinado, validado e em formato PDF.",
    TITULO_RELATORIO_REPROVADO: "8. Relatório técnico de obtenção — reprovado",
    TITULO_DESCRITORES_REPROVADO: "9. Tabela de descritores — reprovada",
};
